import { render, staticRenderFns } from "./DateSelect.vue?vue&type=template&id=871e7218&scoped=true"
import script from "./DateSelect.vue?vue&type=script&lang=js"
export * from "./DateSelect.vue?vue&type=script&lang=js"
import style0 from "./DateSelect.vue?vue&type=style&index=0&id=871e7218&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871e7218",
  null
  
)

export default component.exports